import React, { useState, useEffect } from 'react';
import AddEquipo from './AddEquipo'; // Asegúrate de importar el componente AddEquipo
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

function GestionEquipos({  }) {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [equipos, setEquipos] = useState([]);
    const [editingEquipo, setEditingEquipo] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [equipoToDelete, setEquipoToDelete] = useState(null);
    const { user } = useUser();

    const fetchEquipos = async () => {
        try {
            const response = await fetch(`${server}/MgEquipoes`);
            const data = await response.json();
            setEquipos(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar los equipos: ' + error,
            });
        }
    };

    const handleNewEquipo = () => {
        fetchEquipos();
        setEditingEquipo(null);
    };

    useEffect(() => {
        fetchEquipos();
    }, []);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleOpenDialog = (equipo) => {
        setEquipoToDelete(equipo);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setEquipoToDelete(null);
    };

    const handleDeleteEquipo = async () => {
        if (equipoToDelete) {
            try {
                const username = ''+user.codigoUsuario+'/';
                const response = await fetch(`${server}/MgEquipoes/${equipoToDelete.id}/${username}`, {
                    method: 'DELETE'
                });
                if (response.ok) {
                    handleCloseDialog();
                    fetchEquipos();
                   
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Equipo eliminado con éxito',
                    });
                } else {
                    handleCloseDialog();

                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });
                }
            } catch (error) {
             
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al eliminar el equipo: ' + error,
                });
            }
        }
    };

    const filteredEquipos = equipos.filter(equipo => equipo.descripcion?.toLowerCase().includes(searchQuery.toLowerCase()));

    return (
        <>
            <div className="x_title">

            </div>
            <div className="x_content">
                <br />
                <AddEquipo onNewEquipo={handleNewEquipo} editingEquipo={editingEquipo} />
                <div className="ln_solid" />

                <h2>Equipos Existentes</h2>
                <div className="row">
                    <div className="col-md-7 col-sm-4 offset-md-2">
                        <TextField
                            variant="outlined"
                            label="Buscar equipo"
                            fullWidth
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />
                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Nombre</TableCell>
                                            <TableCell>Descripción</TableCell>
                                            <TableCell align="right">Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredEquipos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((equipo) => (
                                            <TableRow key={equipo.id}>
                                                <TableCell>{equipo.nombre}</TableCell>
                                                <TableCell>{equipo.descripcion}</TableCell>
                                                <TableCell align="right">
                                                    <Button onClick={() => setEditingEquipo(equipo)} color="primary" disabled={!tienePermiso('Editar Equipo')}>Editar</Button>
                                                    <Button onClick={() => handleOpenDialog(equipo)} color="secondary" disabled={!tienePermiso('Eliminar Equipo')}>Eliminar</Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={filteredEquipos.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                                />
                            </TableContainer>
                            <Dialog
                                open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ¿Estás seguro de que deseas eliminar el equipo seleccionado?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                    <Button onClick={handleDeleteEquipo} color="primary" autoFocus>Eliminar</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GestionEquipos;
